import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';

export const useStyles = makeStyles(() => createStyles({
  TileTagWrapper: {
    display: 'flex',
    gap: '20px',
  },
}));
